import React from "react";
import moment from "moment";
import { t } from "../../../helpers/translator";

export default function freeBetBonus() {
	const { loading, data } = this.state;
	if (loading) {
		return <div className="loading-betbonus">Loading...</div>;
	} else if (data.bonuses.length) {
		return (
			<div className="ticket-results-view-p">
				{console.log(data.bonuses)}
				{data.bonuses.map(el => {
					return (
						<div key={el.id} className="betbonus-container">
							<div className="betbonus-container-header">
								<p>{el.name}</p>
								<p>
									{t("Amount:")} {el.amount}
								</p>
							</div>
							<div className="betbonus-text-container">
								<p>{el.description}</p>
								<div className="date-container-betbonus">
									<div>
										<span className="date-text">
											{t("Expiration date:")}
										</span>{" "}
										{moment
											.unix(
												el.client_bonus_expiration_date
											)
											.format("YYYY-MM-DD HH:mm")}
									</div>
									<div>
										<span className="date-text">
											{t("Start date")}
										</span>{" "}
										{moment
											.unix(el.start_date)
											.format("YYYY-MM-DD HH:mm")}
									</div>
									<div>
										<span className="date-text">
											{t("End date")}:
										</span>{" "}
										{moment
											.unix(el.end_date)
											.format("YYYY-MM-DD HH:mm")}
									</div>
								</div>
							</div>
						</div>
					);
				})}
			</div>
		);
	} else {
		return <p className="bet-bonus-null">{t(`There are no available free bet bonuses.`)}</p>;
	}
}
